// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Category from './Category';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Category);
